__turbopack_context__.v({
  "legal-disclaimer": "OnboardingNameDetailsPageForMobile-module-scss-module__je-2MG__legal-disclaimer",
  "legal-disclaimer-link": "OnboardingNameDetailsPageForMobile-module-scss-module__je-2MG__legal-disclaimer-link",
});
